import Post from "@/components/Post/Post.vue";
import PostCompact from "@/components/Post/PostShort.vue";
import { FEED_VIEW_TYPES } from "@/constants/feedViewTypes";

export const FEED_VIEW_COMPONENTS = {
  [FEED_VIEW_TYPES.DEFAULT]: Post,
  [FEED_VIEW_TYPES.COMPACT]: PostCompact,
};
